<template>
  <div class="filter">
    <div class="filter__inner">
      <div v-if="$slots.search" class="filter__search">
        <slot name="search" />
      </div>
      <div class="filter__detail">
        <div v-if="$slots.date" class="filter__date">
          <slot name="date" />
        </div>
        <div v-if="$slots.show" class="filter__show">
          <slot name="show" />
        </div>
        <div v-if="$slots.language" class="filter__language">
          <slot name="language" />
        </div>
        <div v-if="$slots.category" class="filter__category">
          <slot name="category" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
@use "~/assets/sass/tools";

.filter {
  &__inner {
    @include tools.grid;
  }

  &__date {
    input[type='date'] {
      box-sizing: border-box;
      @include tools.to(tools.$breakpoint--desktop) {
        width: 100%;
      }
      @include tools.form-field-date;
    }
  }

  &__search {
    grid-column: 1 / span 6;

    input[type='search'] {
      @include tools.form-field-search;
    }

  }

  &__detail {
    gap: calc(var(--grid-gutter) / 2);
    grid-column: 1 / span 6;
    /* stylelint-disable */
    @include tools.grid;
    @include tools.to(tools.$breakpoint--desktop) {
      @include tools.grid($columns: 1);
    }
    /* stylelint-enable */
  }

  &__show,
  &__language,
  &__category {
    select {
      min-width: 234px;
      @include tools.form-field-select;
    }
  }
}
</style>
